import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import i18n, { DEFAULT_LANGUAGE, toLanguage } from "./common/locales/i18n";
import "./globals.css";
import { App } from "./app";
import { HydrationLanguageSync } from "./common/components/hydration-language-sync";
import { createSiteRouter } from "./common/navigations/site-router";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found!");

const router = createSiteRouter();

const renderClient = () => {
	createRoot(root).render(
		<StrictMode>
			<App>
				<RouterProvider router={router} />
			</App>
		</StrictMode>,
	);
};

const hydrateClient = async () => {
	const detectedLanguage = toLanguage(i18n.resolvedLanguage);
	if (detectedLanguage !== DEFAULT_LANGUAGE) {
		await i18n.changeLanguage(DEFAULT_LANGUAGE);
	}

	hydrateRoot(
		root,
		<StrictMode>
			<App>
				<RouterProvider router={router} />
				<HydrationLanguageSync language={detectedLanguage} />
			</App>
		</StrictMode>,
	);
};

if (root.hasChildNodes()) {
	void hydrateClient();
} else {
	renderClient();
}
